import { useNavigate } from "react-router-dom";
import { broadcastCreateService, registerUserService } from "../utils/api";
import { notifyError, notifySuccess } from "../utils/notify";
import { DashboardLayout } from "./_common/DashboardLayout";
import { UserForm } from "./components/UserForm";
import { RegisterUserForm } from "./components/RegisterUserForm";

export function UserCreate() {

    const navigate = useNavigate();

    return (
        <DashboardLayout route="/users">
            <h1 className="text-4xl font-semibold">Add User</h1>

            <div className="mt-6">
                <div className="grid grid-cols-3 gap-4">
                    <div className="col-span-1">
                        <RegisterUserForm 
                            onSubmit={(data) => {
                                registerUserService(data, (data) => {
                                    if (data.success) {
                                        notifySuccess(data.message)
                                        navigate('/users')
                                    } else {
                                        notifyError(data.message)
                                    }
                                })
                            }} 
                        />
                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}